var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Policy-content-mian",class:{ 'Policy-content-mian-mobile': _vm.isMobile }},_vm._l((_vm.dataList),function(item){return _c('PolicyContentItem',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }